export const getBucketMatchups = () => ({
  matchUpBucketedStats: {
    bucketsMeta: [
      {
        type: 'SINGLES',
        matchUpStatsBuckets: [
          {
            totalMatches: 28,
            matchesWon: 24,
            matchesLost: 4,
            month: 1,
            year: 2021,
            __typename: 'statBucket',
          },
          {
            totalMatches: 18,
            matchesWon: 14,
            matchesLost: 4,
            month: 2,
            year: 2021,
            __typename: 'statBucket',
          },
          {
            totalMatches: 19,
            matchesWon: 5,
            matchesLost: 14,
            month: 3,
            year: 2021,
            __typename: 'statBucket',
          },
          {
            totalMatches: 12,
            matchesWon: 2,
            matchesLost: 10,
            month: 4,
            year: 2021,
            __typename: 'statBucket',
          },
          {
            totalMatches: 18,
            matchesWon: 10,
            matchesLost: 8,
            month: 5,
            year: 2021,
            __typename: 'statBucket',
          },
          {
            totalMatches: 10,
            matchesWon: 7,
            matchesLost: 3,
            month: 6,
            year: 2021,
            __typename: 'statBucket',
          },
          {
            totalMatches: 14,
            matchesWon: 7,
            matchesLost: 7,
            month: 7,
            year: 2021,
            __typename: 'statBucket',
          },
          {
            totalMatches: 5,
            matchesWon: 3,
            matchesLost: 2,
            month: 8,
            year: 2021,
            __typename: 'statBucket',
          },
          {
            totalMatches: 4,
            matchesWon: 4,
            matchesLost: 0,
            month: 9,
            year: 2021,
            __typename: 'statBucket',
          },
          {
            totalMatches: 7,
            matchesWon: 3,
            matchesLost: 4,
            month: 11,
            year: 2021,
            __typename: 'statBucket',
          },
          {
            totalMatches: 5,
            matchesWon: 3,
            matchesLost: 2,
            month: 12,
            year: 2021,
            __typename: 'statBucket',
          },
        ],
        __typename: 'BucketMeta',
      },
    ],
    __typename: 'BucketedMatchUpStats',
  },
})
